import React from 'react'
import { AiFillCheckCircle } from 'react-icons/ai';
import { AdCategorie, CampaignBudget } from "../..";
import { BiToggleLeft, BiToggleRight } from 'react-icons/bi';
import { Link } from 'react-router-dom';


type CampaignFormProps = {
  openCampaignAwareness: boolean;
  setOpenCampaignAwareness: React.Dispatch<React.SetStateAction<boolean>>;
}

const CampaignForm: React.FC<CampaignFormProps> = ({ openCampaignAwareness, setOpenCampaignAwareness }) => {
  const [toggleSwitches, setToggleSwitches] = React.useState(false);
  return (
    <div className='w-full flex flex-col gap-10 font-Poppins'>
      <div className="flex justify-center bg-white rounded-lg p-8 flex-col gap-1 shadow-[0px_4px_16px_0px_rgba(24,119,242,0.08)]">
        <div className="flex gap-2 items-center">
          <AiFillCheckCircle className='fill-green-500'/>
          <h1 className='text-[#555] font-semibold text-lg'>Campaign name</h1>
        </div>
        <div className="pl-6 flex pr-12 justify-start items-center gap-5">
          <input 
            type="text"
            placeholder='New awareness Campaign'
            className='w-[82%] h-11 pl-5 py-3 border-[#CCC] border-solid border rounded-lg placeholder:text-[#CCC] placeholder:font-Poppins placeholder:font-normal placeholder:text-xs' 
          />
          <h1 className='text-midGreen font-normal text-sm'>Create template</h1>
        </div>
      </div>
      <AdCategorie/>

      <div className="flex justify-center bg-white rounded-lg p-8 flex-col shadow-[0px_4px_16px_0px_rgba(24,119,242,0.08)] gap-2">
        <div className="flex justify-between items-center">
          <h3 className="font-semibold text-lg text-[#555]">A/B Test</h3>
          <div className="flex gap-2 items-center">
            <h3 className='text-[#555] text-base font-semibold'>Create A/B Test</h3>
            {
              !toggleSwitches
              ?
              <BiToggleLeft 
                size={24} 
                className='cursor-pointer' 
                onClick={() => setToggleSwitches(!toggleSwitches)}
              />
              :
              <BiToggleRight 
                size={24} 
                className='text-[#CCC] cursor-pointer' 
                onClick={() => setToggleSwitches(!toggleSwitches)}
              />
            }
          </div>
        </div>
        <p className='text-[#727272] text-sm font-normal mt-2'>
          To help improve ad performance, 
          test versions with different images, 
          text, audiences or placement. For accuracy, 
          each one will be shown to separate group of your audience.
        </p>
      </div>

      <CampaignBudget/>

      <div className="mt-16 pl-[38px] flex justify-between pr-36 ">
        <div 
          className="flex items-center justify-center rounded-lg w-[123px] h-11 bg-[#CEC7F8] text-sm font-semibold text-black cursor-pointer active:w-[115px] active:m-[3px] active:h-10"
        >
          <Link to="/ad-manager/dashboard">
            Cancel
          </Link>
        </div>
        <div 
          className="flex items-center justify-center rounded-lg w-[123px] h-11 bg-midGreen text-sm font-semibold text-white active:w-[115px] active:m-[3px] active:h-10 cursor-pointer"
          onClick={() => setOpenCampaignAwareness(!openCampaignAwareness)}
        >
          Next
        </div>
      </div>
    </div>
  )
}

export default CampaignForm;